import * as React from "react";
import SearchDropdownFilter from "../SearchDropdownFilter";

export class EnumCustomFieldFilter extends SearchDropdownFilter<string> {

	itemToId(item: string): string {
		return item;
	}

	itemToLabel(item: string): string {
		return item;
	}
}
